import { VendorLayout } from '../../../components/Vendor';
import { usePageTitle } from '../../../hooks';

export function Vendors() {
  usePageTitle('vendor:title');
  return <VendorLayout />;
}
